export const OD_PROD_CODE = '0110'
export const TPL_PROD_CODE = '0100'

export const customerTypeMap = {
  INDIVIDUAL: 0,
  COMPANY: 1
}
